const getters = {
  showModal: state => {
    return state.showModal
  },
  selectedItem: state => {
    return state.selectedItem
  },
  rangeEdit: state => {
    return state.rangeEdit
  },
  selectedRange: state => {
    return state.selectedRange
  }
}

export default getters
